import { render, staticRenderFns } from "./clueSuspend.vue?vue&type=template&id=6bf977de&scoped=true"
import script from "./clueSuspend.vue?vue&type=script&lang=js"
export * from "./clueSuspend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf977de",
  null
  
)

export default component.exports